// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface PostJoinOrganizationRequestPayload {
  invitation: string;
}

export interface PostJoinOrganizationSuccessPayload {}

export interface PostJoinOrganizationFailPayload {
  error: Error;
}

export const postJoinOrganizationActions = createAsyncAction(
  'elearning/POST_JOIN_ORGANIZATION',
  'elearning/POST_JOIN_ORGANIZATION_SUCCESS',
  'elearning/POST_JOIN_ORGANIZATION_FAIL'
)<
  PostJoinOrganizationRequestPayload,
  PostJoinOrganizationSuccessPayload,
  PostJoinOrganizationFailPayload
>();
